import { Contact } from '@shared/components/ContactPicker';
import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';
import type { ClientVisitSummaryDto } from '../visits/entity';
import { Client, ClientWithVisitsWithVisitServices, PartialClient } from './entity';

export const clientApi = {
  getById: (clientId: string) => `/api/clients/${encodeURIComponent(clientId)}`,
  getAll: () => '/api/clients/',
  delete: (clientId: string) => `/api/clients/${encodeURIComponent(clientId)}`,
  create: () => '/api/clients',
  import: () => '/api/clients/import',
  getVisits: (clientId: string) => `/api/visits/client/${encodeURIComponent(clientId)}`,
  search: (clientIds?: string[]) => {
    const params = new URLSearchParams();

    if (clientIds?.length) {
      clientIds.forEach(id => params.append('ids', id));
    }

    return `/api/clients/search?${params.toString()}`;
  },
};

export const getClientById = async (clientId: string): Promise<ClientWithVisitsWithVisitServices> =>
  apiCall(async () => await axiosInstance.get(clientApi.getById(clientId)), 'api.client.notFound');

export const getClients = async (): Promise<Client[]> =>
  apiCall(async () => await axiosInstance.get(clientApi.getAll()), 'api.client.listNotFound');

export const getClientVisits = async (clientId: string): Promise<ClientVisitSummaryDto[]> =>
  apiCall(
    async () => await axiosInstance.get(clientApi.getVisits(clientId)),
    'api.client.visitsNotFound',
  );

export const postCreateNewClient = async (clientData: PartialClient): Promise<PartialClient> =>
  apiCall(
    async () => await axiosInstance.post(clientApi.create(), clientData),
    'api.client.createError',
  );

export const postImportContacts = async (data: { contacts: Contact[] }): Promise<boolean> =>
  apiCall(async () => await axiosInstance.post(clientApi.import(), data), 'api.client.importError');

export const deleteClient = async (clientId: string): Promise<Client> =>
  apiCall(
    async () => await axiosInstance.delete(clientApi.delete(clientId)),
    'api.client.deleteError',
  );

export const getSearchClients = async (
  payload: string[],
): Promise<ClientWithVisitsWithVisitServices[]> =>
  apiCall(async () => await axiosInstance.get(clientApi.search(payload)), 'api.client.searchError');
